import Vue from 'vue';
import Vuex from 'vuex';
import { firebase } from '@/services/firebase';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    meetingSuites: {},
    registrations: [],
    user: {
      isLoggedIn: false,
      isAdmin: false,
      fullName: null,
      meetings: {}
    },
    showArchived: false
  },

  getters: {
    meetingSuites(state) {
      return state.meetingSuites;
    },
    user(state) {
      return state.user;
    },
    registrations(state) {
      return state.registrations;
    },
    token() {
      return firebase.auth().currentUser.getIdToken();
    }
  },

  mutations: {
    setMeetingSuites(state, suitesObj) {
      state.meetingSuites = suitesObj;
    },
    setUser(state, userObj) {
      state.user = userObj;
    },
    setMeetingRegistrations(state, registrations) {
      if (!registrations || !registrations.sort) {
        state.registrations = [];
      } else {
        state.registrations = registrations
          .sort((a, b) => (a.lastName > b.lastName ? 1 : -1))
          .map(reg => {
            const suffix = reg.suffix ? ` ${reg.suffix}` : '';
            const companyName = reg.companyName ? ` (${reg.companyName})` : '';
            return {
              ...reg,
              display: `${reg.lastName}${suffix}, ${reg.firstName}${companyName}`
            };
          });
      }
    },
    setShowArchived(state, value) {
      state.showArchived = value;
    }
  },

  actions: {
    toggleShowArchived({ state, commit }) {
      commit('setShowArchived', !state.showArchived);
    }
  }
});



// WEBPACK FOOTER //
// ./src/services/store.js